export default __webpack_public_path__ + "static/media/traetment_selected.12e00392.svg";